module.exports = __webpack_public_path__ + "img/uploaddemo-2-b.6b2b1355.png";